import { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL_DOCS } from "@/lib/legal";
import { Reveal, ChapterLabel } from "@/components/landing/Reveal";

const LegalPage = ({ docKey }) => {
    const d = LEGAL_DOCS[docKey];

    useEffect(() => {
        if (d) document.title = d.title;
        return () => {
            document.title = "BookMyVIP | VIP Table Booking in Thailand";
        };
    }, [d]);

    if (!d) return <Navigate to="/" replace />;

    return (
        <main
            data-testid={`legal-page-${docKey}`}
            className="mx-auto max-w-3xl px-5 pb-32 pt-32 md:px-10 md:pt-40"
        >
            <Reveal>
                <Link
                    data-testid="legal-back-link"
                    to="/"
                    className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-muted transition-colors duration-300 hover:text-gold"
                >
                    <ArrowLeft size={14} strokeWidth={1.5} /> Home
                </Link>
            </Reveal>
            <Reveal delay={0.05}>
                <div className="mt-10">
                    <ChapterLabel number="BookMyVIP" title="Legal" testId="legal-label" />
                </div>
            </Reveal>
            <Reveal delay={0.1}>
                <h1 className="mt-8 font-serif text-4xl font-medium tracking-tight text-ivory md:text-6xl">
                    {d.heading}
                </h1>
            </Reveal>
            <Reveal delay={0.15}>
                <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.3em] text-muted">
                    {d.updated}
                </p>
            </Reveal>

            <div className="mt-14 space-y-10">
                {d.sections.map((s, i) => (
                    <Reveal key={s.h} delay={0.05 + i * 0.04}>
                        <div className="border-t border-white/10 pt-8">
                            <h2 className="text-xs font-bold uppercase tracking-[0.25em] text-gold">
                                {String(i + 1).padStart(2, "0")} — {s.h}
                            </h2>
                            <p className="mt-4 text-sm leading-relaxed text-muted md:text-base">
                                {s.b}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </main>
    );
};

export default LegalPage;
